module.exports = __webpack_public_path__ + "static/media/dinosaur(2).9a287cc2.PNG";